import { PurchaseOrderDetailPrint } from "./purchase-order-detail-print.model";

export class PurchaseOrderPrintModel {
    purchaseOrderId: number = 0;
    companyId: number = 0;
    branchId: number = 0;
    branchCode: number = 0;
    branchName: string = "";
    branchAddress: string = "";
    branchPhone: string = "";
    consecutive: number = 0;
    enterpriseId: number = 0;
    enterpriseNit: string = "";
    enterpriseName: string = "";
    datePurchaseOrder: Date = new Date;
    referenceDocument: string = "";
    providerNit: string = "";
    providerBusinessName: string = "";
    providerAddress: string = "";
    providerPhone: string = "";
    enterpriseNit2: string = "";
    enterpriseName2: string = "";
    branchPhone2: string = "";
    address: string = "";
    subtotalValue: number = 0;
    ivaValue: number = 0;
    totalValue: number = 0;
    observation: string = "";

    purchaseOrderDetails: PurchaseOrderDetailPrint[] = [];
}
